import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';

const SortDirType = {
    ASC: 'asc',
    DESC: 'desc'
};

const WithSortStateTypes = {
    sortResultsByPrice: PropTypes.func.isRequired,
    paymentFrequencySelected: PropTypes.oneOf(['annual', 'monthly']).isRequired,
    sortDir: PropTypes.oneOf(Object.values(SortDirType)).isRequired
};

const withSortState = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            return <Component { ...this.props } />;
        }

    }

    WithState.propTypes = WithSortStateTypes;

    return connect(mapStateToProps, mapDispatchToProps)(WithState);
};

const mapStateToProps = (state) => {
    const paymentFrequencySelected = resultsConfigSelector(state).getIn(['filters', 'frequency']);
    const sortDir = resultsConfigSelector(state).getIn(['sorting', 'sortDir']);
    return {
        paymentFrequencySelected,
        sortDir
    };
};

const mapDispatchToProps = (dispatch) => ({
    sortResultsByPrice: (frequency, sortDir) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir,
            sortType: 'numeric'
        });
    }
});

export { withSortState, SortDirType, WithSortStateTypes };
